import A from './a';
import B from './b';
import C from './c';

export default {
  A,
  B,
  C,
};
